/**
 * @generated SignedSource<<9a331f80594282d6909efdcabe9b17ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreativeAdvisorMetaAd$data = {
  readonly insights: ReadonlyArray<{
    readonly id: string;
    readonly text: string;
    readonly " $fragmentSpreads": FragmentRefs<"CreativeAdvisorInsight">;
  }> | null;
  readonly " $fragmentType": "CreativeAdvisorMetaAd";
};
export type CreativeAdvisorMetaAd$key = {
  readonly " $data"?: CreativeAdvisorMetaAd$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreativeAdvisorMetaAd">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreativeAdvisorMetaAd",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Insight",
      "kind": "LinkedField",
      "name": "insights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CreativeAdvisorInsight"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MetaAd",
  "abstractKey": null
};

(node as any).hash = "57870549753aa4f5e22ba205cfee7032";

export default node;
